import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from '../../Utils/reactIntlCompat';
import Typography from '@mui/material/Typography';

const EmptyInfiniteListComponent = function EmptyInfiniteListComponent({
  intl,
  customMessage = null,
}) {
  return (
    <Typography variant="body1" sx={{
      p: "16px"
    }}>
      {customMessage || intl.messages.NO_ITEMS}
    </Typography>
  );
};

EmptyInfiniteListComponent.propTypes = {
  customMessage: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(EmptyInfiniteListComponent);
